// extracted by mini-css-extract-plugin
export var editButton = "_k8-0";